<template>
    <MainContent>
        <template v-slot:header v-if="abonado">
            <PageTitle title="Detalles del abonado"></PageTitle>
            <div>
                <OpcionesDropdownComponent class="mt-2" v-bind:options="[
                    { to: { name: 'back.abonados.editar', params: { abonado_id: abonado.id}}, label: 'Editar'},
                    ...abonado.esta_renovado ? [
                        { type: 'url', url: abonado.url_imprimir, label: 'Imprimir' },
                        { type: 'action', action:() => enviarAbono(abonado.id), label: 'Enviar'},
                        { type: 'action', action:() => $modal.show('cambiar-asiento-' + abonado.id), label: 'Cambiar butaca'},
                    ] : []
                ]"/>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <div class="row">
                    <template v-if="manager.lfp">
                        <div class="alert alert-info">
                            Para más información, por favor consulte SGA
                        </div>
                    </template>

                    <b-list-group class="container-fluid list-group-unbordered mb-3">
                        <div class="d-md-flex">
                            <div class="col-md-6 col-sm-12 col-xs-12">
                                <h3 class="card-title ml-sm-4 mt-sm-2">Datos del abonado: {{ abonado.name }} {{ abonado.surnames }}</h3><br><br>
                                <div class="ml-4">
                                    <b-list-group-item>
                                        <b>Nª de abonado: </b> {{ abonado.n_abonado }}
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>Nombre: </b> <a>{{ abonado.name }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>Apellidos: </b> <a>{{ abonado.surnames }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>Género: </b> <a>{{ abonado.genero }}</a>
                                    </b-list-group-item>

                                    <template v-if="!manager.lfp">
                                        <b-list-group-item>
                                            <b>Fecha de nacimiento: </b> <a>{{ abonado.fecha_nacimiento }}</a>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>Teléfono: </b> <a>{{ abonado.telefono }}</a>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>DNI: </b> <a>{{ abonado.dni }}</a>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>País:</b> {{ abonado.pais }}
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>Provincia:</b> {{ abonado.provincia }}
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>Localidad: </b> {{ abonado.localidad }}
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>Domicilio:</b> {{ abonado.domicilio }}
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>CP/ZIP CODE:</b> {{ abonado.cp }}
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>Email: </b> <a>{{ abonado.email }}</a>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <b>Peña: </b> {{ abonado.penista }}
                                        </b-list-group-item>
                                    </template>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-12 col-xs-12">
                                <h3 class="card-title ml-sm-4 mt-sm-2">Datos del abono</h3><br><br>
                                <div class="ml-4 mr-4">
                                    <b-list-group-item v-if="abonado.transacciones && abonado.transacciones.length > 0">
                                        <b>Método de pago: </b> <a>{{ abonado.transacciones[abonado.transacciones.length - 1].metodo_pago | formatear_metodo_pago }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item v-if="abonado.observaciones">
                                        <b>Observaciones: </b> <a>{{ abonado.observaciones }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>IBAN:</b> {{ abonado.iban }}
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>Titular de la cuenta:</b> {{ abonado.titular_cuenta }}
                                    </b-list-group-item>
                                    <b-list-group-item v-if="abonado.fecha_alta && !abonado.n_abonado_antiguo">
                                        <b>Fecha de alta: </b> <a>{{ abonado.fecha_alta }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item v-if="abonado.fecha_antiguedad">
                                        <b>Fecha de antigüedad: </b> <a>{{ abonado.fecha_antiguedad }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>Tipo de abono: </b>
                                        <a>
                                            <template v-if="abonado.es_internacional">
                                                Internacional
                                            </template>
                                            <template v-else>
                                                <template v-if="abonado.precio != null">
                                                    {{ abonado.precio.descripcion }}
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </template>
                                        </a>
                                    </b-list-group-item>
                                    <b-list-group-item v-if="abonado.vendido_por">
                                        <b>Vendido por: </b>
                                        <a v-if="abonado.transacciones[0].metodo_pago != 5">{{ abonado.vendido_por.name }} / {{ abonado.vendido_por.email }}</a>
                                        <a v-else>TPV Online</a>
                                    </b-list-group-item>
                                    <b-list-group-item v-if="abonado.origen">
                                        <b>Origen: </b> <a>{{ abonado.origen }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item v-if="abonado.fecha_alta && abonado.n_abonado_antiguo">
                                        <b>Fecha de renovación:</b> <a>{{ abonado.fecha_alta }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item v-if="abonado.footter">
                                        <b>Código footter:</b> <a>{{ abonado.footter }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>Qr code: </b> <a>{{ abonado.qr_code }}</a>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>Precio:</b>
                                        <a>
                                            <template v-if="abonado.descuento != null">
                                                {{ abonado.descuento.descripcion }} ({{ abonado.descuento.precio | formatear_precio }})
                                            </template>
                                            <template v-else>
                                                -
                                            </template>
                                        </a>
                                        <Button type="button" name="button" class="ml-3" @click="$modal.show('cambiar-precio-' + abonado.id);">Cambiar tipo de abono y precio</Button>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <b>Asiento Zona:</b>
                                        <a>
                                            <template v-if="abonado.tiene_asiento">
                                                {{ abonado.asiento.region }}, Fila: {{ abonado.asiento.row }}, Butaca: {{ abonado.asiento.seat }}
                                            </template>
                                            <template v-else>
                                                Sin asiento
                                            </template>
                                        </a>
                                        <Button type="button" name="button" class="ml-3" @click="$modal.show('cambiar-asiento-' + abonado.id);">CAMBIAR</Button>
                                    </b-list-group-item>
                                </div>
                            </div>
                        </div>
                    </b-list-group>

                    <div class="col-12" id="plazos" v-if="abonado.plazos.length > 0">
                        <div class="row">
                            <div class="col-12">
                                <h3>Plazos</h3>
                            </div>
                            <div class="col-12">
                                <table class="table table-hover text-nowrap">
                                    <thead>
                                    <tr>
                                        <th class="text-center">Importe</th>
                                        <th class="text-center">Información</th>  
                                        <th class="text-center">Pagado</th>
                                        <th class="text-center">Nº de pedido</th>
                                        <th class="text-center">Fecha de pago</th>
                                        <th class="text-center">Opciones</th>                                        
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(plazo, index) in abonado.plazos">
                                            <tr :key="index">
                                                <td class="text-center">
                                                    <template v-if="plazo.descuento_aplicado > 0">
                                                        <del>({{ plazo.importe + plazo.descuento_aplicado | formatear_precio }})</del> - {{ plazo.importe | formatear_precio }}
                                                    </template>
                                                    <template v-else>
                                                        {{ plazo.importe | formatear_precio }}
                                                    </template>
                                                    
                                                </td>
                                                <td class="text-center">
                                                    {{ plazo.informacion }}
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="plazo.pagado"/>
                                                </td>
                                                <td class="text-center">
                                                    {{ plazo.tpv_order }}
                                                </td>
                                                <td class="text-center">
                                                    {{ plazo.fecha_pago }}
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="! plazo.pagado">
                                                        <Button @click="pagarPlazo(plazo.id)">Pagar</Button>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="index != 0">
                                                            <Button @click="anularPlazo(plazo.id)">Anular pago</Button>
                                                        </template>                                                        
                                                    </template>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>                        
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <template v-if="abonado.transacciones.length > 0">
                        <div class="col-12" id="transacciones">
                            <Transacciones :transacciones="abonado.transacciones" @actualizar="getAbonado()" />
                        </div>

                        <div class="col-12">
                            <hr>
                        </div>
                    </template>

                    <div class="col-12" id="eventos-asistidos">
                        <EventosAsistidos :eventos="abonado.eventos_asistidos" :temporada="abonado.temporada"/>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12" id="sanciones">
                        <Sanciones :sanciones="abonado.sanciones" :abonado="abonado" @actualizar="getAbonado()" />
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12" id="observaciones">
                        <Observaciones :abonado="abonado" @actualizar="getAbonado()" />
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12">
                        <h3>Documentos subidos:</h3>
                        <ul class="list-unstyled">
                            <template v-for="documento in abonado.documentos">
                                <li :key="documento.id">
                                    <a :href="documento.url" target="_blacnk" class="btn-link text-secondary"><i class="far fa-fw fa-image "></i> {{ documento.nombre }}</a>
                                    <button style="border: 0; background-color: white;" @click="borrarDocumento(documento.id)">&#10006;</button>
                                </li>
                            </template>
                        </ul>
                        <div class="col-12 col-md-6 col-lg-12">
                            <label>Subir documentación</label>
                            <vue-dropzone
                                ref="myVueDropzone"
                                id="dropzone"
                                :options="dropzoneOptions"
                                v-on:vdropzone-success="imagenSubida"
                                v-on:vdropzone-removed-file="imagenBorrada"
                                :useCustomSlot=true
                            >
                                <div class="dropzone-custom-content">
                                    <h3 class="dropzone-custom-title">Arrastra los archivos aquí para subirlos</h3>
                                </div>
                            </vue-dropzone>
                        </div>
                    </div>
                </div>

                <CambiarAsiento :abonado="abonado" v-on:close="cerrarModalCambiarAsiento" v-on:asientoEditado="asientoEditado"></CambiarAsiento>
                <CambiarPrecio :abonado="abonado" v-on:close="cerrarModalPrecio"></CambiarPrecio>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import CambiarAsiento from '@/views/backend/abonados/modals/CambiarAsiento';
    import CambiarPrecio from '@/views/backend/abonados/modals/CambiarPrecio';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import MainContent from "@/components/backend/components/MainContent";
    import OpcionesDropdownComponent
    from "@/components/backend/components/OpcionesDropdownComponent";
    import PageTitle from '@/components/backend/components/PageTitleComponent';
    import EventosAsistidos from '@/components/backend/abonados/EventosAsistidos.vue';
    import Sanciones from '@/components/backend/abonados/Sanciones.vue';
    import Transacciones from '@/components/backend/abonados/Transacciones.vue';
    import Observaciones from '@/components/backend/abonados/Observaciones.vue';

    export default {
        props: ['abonado_id'],
        data() {
            return {
                abonado: null,
                loading: true,
                dropzoneOptions: {}
            }
        },
        created() {
            this.getAbonado();
            this.setDropzone();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
        },
        methods: {
            asientoEditado() {
                this.getAbonado();
                this.$toast.success("¡Asiento editado!");
            },
            imagenBorrada() {

            },
            imagenSubida(file, response) {
                this.getAbonado();
            },
            borrarDocumento(id) {
                this.loading = true;

                const params = {
                    abonado_id: this.abonado_id,
                    documento_id: id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.borrar.documento'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getAbonado();
                }).catch((error) => {
                    this.$toast.error('El archivo que intentas borrar no existe');
                    this.loading = false
                });
            },
            setDropzone() {
                this.dropzoneOptions = {
                url: this.config.API_BASE + '/f/upload/documento?tid=' + this.configuracion.hash_teatro + '&abonado_id=' + this.abonado_id,
                    thumbnailWidth: 150,
                    maxFilesize: 20,
                    headers: {
                        'Accept': 'application/json'
                    },
                    uploadMultiple: false,
                    maxFiles: 5
                }
            },
            cerrarModal(modal, actualizar) {
                this.$modal.hide(modal);
                if(actualizar) {
                    this.getAbonado();
                }
            },
            cerrarModalPrecio(id, cambiado) {
                this.$modal.hide('cambiar-precio-' + id);
                if(cambiado) {
                    this.getAbonado();
                }
            },
            cerrarModalCambiarAsiento(id) {
                this.$modal.hide('cambiar-asiento-' + id);
            },
            getAbonado : function() {
                this.loading = true;

                const params = {
                    abonado_id: this.abonado_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.show'), params).then(res => {
                    this.abonado = res.data.data;
                }).finally(() => this.loading = false);
            },
            pagarPlazo(plazo_id) {
                this.loading = true;

                const params = {
                    abonado_id: this.abonado_id,
                    plazo_id: plazo_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.plazos.pagar'), params).then(res => {
                    this.getAbonado();
                }).finally(() => this.loading = false);
            },
            anularPlazo(plazo_id) {
                this.loading = true;

                const params = {
                    abonado_id: this.abonado_id,
                    plazo_id: plazo_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.plazos.anular'), params).then(res => {
                    this.getAbonado();
                }).finally(() => this.loading = false);
            },
            enviarAbono (id) {
                const params = {
                    filters : {},
                    abonado_id: id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.abono.enviar'), params).then(res => {
                    this.$toast.success("Abono enviado");
                });
            },
        },
        components: {
            OpcionesDropdownComponent,
            MainContent, CambiarAsiento,
            vueDropzone: vue2Dropzone, CambiarPrecio,
            PageTitle, EventosAsistidos, Sanciones, Transacciones, Observaciones
        }
    }
</script>